// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'picture-solid';

export const Component = () => (
  <path d='M22.055 1.5H2.945c-.42 0-.746.14-1.025.42-.28.281-.42.608-.42 1.028v19.104c0 .42.14.747.42 1.027.28.28.606.421 1.025.421h19.11c.42 0 .746-.14 1.025-.42.28-.281.42-.608.42-1.028V2.948c0-.42-.14-.747-.42-1.027a1.37 1.37 0 0 0-1.025-.421ZM5.415 5.89c.373-.373.84-.56 1.352-.56.514 0 .979.186 1.352.56.373.373.56.84.56 1.355 0 .514-.187.98-.56 1.354a1.861 1.861 0 0 1-1.352.561c-.513 0-.978-.186-1.351-.607-.373-.373-.56-.794-.56-1.307 0-.514.186-.981.56-1.355Zm17.106 13.78v2.38c0 .328-.14.514-.466.514H2.945c-.326 0-.466-.186-.466-.513v-2.382h20.042Zm0-4.111v3.176H2.479v-1.728l5.22-4.81 5.407 5.417a.42.42 0 0 0 .326.14c.326 0 .513-.14.513-.467 0-.14-.047-.28-.14-.326l-2.75-2.803 5.266-4.81 6.199 6.211Z' />
);

export const viewBox = '0 0 25 25';
